export default function GetHealthClassFromBmi(bmi) {
  if (bmi >= 18 && bmi <= 27) {
    return "PP";
  }
  if (bmi >= 27 && bmi <= 31) {
    return "P";
  }
  if (bmi >= 31 && bmi <= 33) {
    return "RP";
  }
  if (bmi > 33) {
    return "R";
  } else {
    return "";
  }
};


// WEBPACK FOOTER //
// ./src/components/Quoters/Digital/Helpers/GetHealthClassFromBmi.js